<template>
    <i class="ico-svg-x-dots">
        <svg v-bind="{ width, height }" viewBox="0 0 20 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0a2 2 0 110 4 2 2 0 010-4zM2 0a2 2 0 110 4 2 2 0 010-4zm16 0a2 2 0 110 4 2 2 0 010-4z" :fill="color" />
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconHorizontalDots',

    props: {
        width: {
            type: Number,
            default: 20,
        },

        height: {
            type: Number,
            default: 4,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
